import moment from "moment";
import {
  City,
  Community,
  Language,
  AdditionalProgram,
} from "../interfaces/admin";
import { ILangObj } from "../interfaces/language";

export const getCityObj = (cities, type?: string) => {
  const options = cities.map(({ id, name }: City) => ({
    id,
    title: name,
    selected: false,
    key: "city",
    value: id,
  }));
  return {
    title: type === "guests" ? "admin.table.cityOfSalon" : "admin.table.city",
    allowMultiple: true,
    isFilterActive: false,
    filterOptions: true,
    options,
    type: "dropdown",
  };
};

export const getCommunityObj = (communities) => {
  const options = communities.map(({ id, name }: Community) => ({
    id,
    title: name,
    selected: false,
    key: "community",
    value: id,
  }));
  return {
    title: "admin.table.assignToCommunity",
    allowMultiple: true,
    isFilterActive: false,
    options,
    type: "dropdown",
  };
};

export const getLanguageObj = (languages) => {
  const options = languages.map(({ id, name }: Language) => ({
    id,
    title: name,
    selected: false,
    key: "language",
    value: id,
  }));
  return {
    title: "admin.table.language",
    allowMultiple: true,
    isFilterActive: false,
    options,
    type: "dropdown",
  };
};

const additionalProgramsTranslation = {
  "Life story": "סיפור חיים",
  "Fulfillment routes": "מסלולי הגשמה",
  "Holiday events": "אירועים בחגים",
  "Happy to talk": "שמחים לדבר",
};

export const getAdditionalProgramsObj = (additionalPrograms) => {
  const options = additionalPrograms.map(({ name }: AdditionalProgram) => ({
    id: name,
    title: additionalProgramsTranslation[name],
    selected: false,
    key: "take_part_in_additional_programs",
    value: name,
  }));
  return {
    title: "admin.witnessProfile.take_part_in_additional_programs",
    allowMultiple: true,
    isFilterActive: false,
    options,
    type: "dropdown",
  };
};

export const getAccessibilityObj = (accessibilities) => {
  const options = accessibilities.map(({ name }) => ({
    id: name,
    title: `admin.table.${[name]}`,
    selected: false,
    key: "accessibility",
    value: name,
  }));
  return {
    title: "admin.salonTeaming.accessibility",
    allowMultiple: true,
    isFilterActive: false,
    options,
    type: "dropdown",
  };
};

export const getSpecialPopulationObj = (populations) => {
  const options = populations.map(({ name }) => ({
    id: name,
    title: `admin.table.${[name]}`,
    selected: false,
    key: "special_population",
    value: name,
  }));
  return {
    title: "admin.witnessProfile.special_population",
    allowMultiple: true,
    isFilterActive: false,
    options,
    type: "dropdown",
  };
};

export const getDateObj = (salondays) => {
  const options = salondays.map(({ date, day_type }, idx) => ({
    id: idx,
    title: moment(date).format("DD-MM-YYYY"),
    selected: false,
    key: "date",
    value: date,
  }));
  return {
    title: "guests.salonSearchMap.availabilityDate",
    allowMultiple: true,
    isFilterActive: false,
    options,
    type: "dropdown",
  };
};

export const getLanguagesForSelector = (languages: Array<ILangObj>) => {
  return languages.map((language) => ({
    key: language.id,
    value: language.name,
  }));
};

export const getAdditionalProgramsTranslation = {
  "Life story": "admin.witnessProfile.life_story",
  "Fulfillment routes": "admin.witnessProfile.fulfillment_routes",
  "Holiday events": "admin.witnessProfile.holiday_events",
  "Happy to talk": "admin.witnessProfile.happy_to_talk",
  "No selection": "admin.witnessProfile.without_value",
};
